import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
    const [isNavOpen, setIsNavOpen] = useState(false);
  
    return (
      <>
        {isNavOpen && (
          <div
            className="nav-overlay"
            onClick={() => setIsNavOpen(false)}
          />
        )}
  
        <nav className="navigation">
          <Link to="/" className="brand-name">
            Alyssa's Blog
          </Link>
  
          <button
            className="hamburger"
            aria-label="Toggle navigation"
            onClick={() => setIsNavOpen(!isNavOpen)}
          >
            ☰
          </button>
  
          <div className={`nav-links ${isNavOpen ? "nav-open" : ""}`}>
            <ul>
              <li onClick={() => setIsNavOpen(false)}>
                <Link to="/">Home</Link>
              </li>
              <li onClick={() => setIsNavOpen(false)}>
                <Link to="/about">About Me</Link>
              </li>
              <li onClick={() => setIsNavOpen(false)}>
                <Link to="/projects">Projects</Link>
              </li>
              <li onClick={() => setIsNavOpen(false)}>
                <Link to="https://github.com/wiserdeveloper">Github</Link>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
};
  

export default Header;
